import React, { FC } from 'react';

import Button, { ButtonProps } from 'ui/components/Buttons';

export const Large: FC<ButtonProps> = props => <Button size='large' {...props} />;

export const Middle: FC<ButtonProps> = props => <Button size='middle' {...props} />;

export const Small: FC<ButtonProps> = props => <Button size='small' {...props} />;
